import { IModel } from "@/@types/models/model";
import { buttonFields } from "@/models/helpers/buttonFields";
import { commonFields } from "./helpers/commonFields";

const Objekti: IModel = {
  title: "Objekti",
  source: "objekti",
  apiPath: "objekti/",
  forms : {
    "default": {
      fields: ["obv", "adrobv", "sifobv", "nasobv",
      "adrobj", "nasobj", "ulobj", "kbobj", "lokacija_id", "zap",]
    },
    "infoDetails": {
      fields: ["id", "adresa_full", "ko_ime", "kc", "broj_etaza", "broj_katova", "broj_dijelova", "pre_pb"]
    },
    "infoForm": {
      fields: [ /*"napomena_picker",*/"napomena"/*, "gl_obj"*/]
    }
  },
  listViews: {
    "default": {
      fields: ["obj_id", "kat", "stambeno", "poslovno", "garaza", "pomocno", "balk_ter", "z_func_o", "neizgr_gr", "ostalo", "ukupno"],
      hidden: ["id"]
    },
    "tooltip": {
      fields: ["obj_id", {"source": "kat", "tooltip": "objekti.kat_uppercase"}, "stambeno", "poslovno", "garaza", "pomocno", "balk_ter", "z_func_o", "neizgr_gr", "ostalo", "ukupno"],
    },
    "attribute_table": {
      fields: ["id", "obj_id", "adresa_full", "kn_zona", "kn_koef", "ko_ime", "kc", "pre_pt", "broj_katova", "deselect", "btn_show_object"],
      hidden: ["id"]
    },
    "processing": {
      fields: ["id", "obj_id", "broj_slika", "adresa_full", "kn_zona", "kn_koef", "ko_ime", "kc", "pre_pt", "broj_katova"],
      hidden: ["id"]
    },
    "object_analysis": {
      fields: ["id", "obj_id", "lokacija_id", "ko_ime", "kc", "adresa_full", "status", "pregledano" ],
      hidden: ["id"]
    },
    "radni_sastanci": {
      fields: ["cut_id", "s", "k", "g", "p", "bt", "j",  "f", "n", "z", "o", "adresa_full", "lokacija_id", "fishnet", "show_katovi", "napomena", "komentar"],
      hidden: ["lokacija_id"]
    },
    "exportExcel": {
      fields: ["id", "s", "k", "g", "p", "bt", "j",  "f", "n", "z", "o", "adresa_full", "napomena", "komentar"]
    },
    "quality_control": {
      fields: ["id", "obj_id", "ko_ime", "kc", "adresa_full", "status" ],
      hidden: ["id"]
    },
    "quality_control_filtered": {
      fields: ["id", "obj_id", "ko_ime", "kc", "adresa_full", "status", "qc_check", "qc_check_on", "qc_check_by", "label"],
      hidden: ["id", "qc_check_by"]
    },
  },
  fields: [
    {
      title: "id",
      source: "id",
      ttoken: "common.id",
      tooltip: "objekti.id",
      type: "numeric",
      idattr: true,
      readonly: true
    },
    {
      title: "id",
      source: "obj_id",
      sort: false,
      ttoken: "objekti.id",
      tooltip: "objekti.id",
      type: "numeric",
    },
    {
      title: "cut_id",
      source: "cut_id",
      ttoken: "common.id",
      tooltip: "common.id",
      type: "text",
      readonly: true
    },
    {
      title: "projekt id",
      source: "projekt_id",
      sort: false,
      ttoken: "objekti.projekti_id",
      tooltip: "objekti.projekti_id",
      type: "numeric",
    },
    {
      title: "fishnet id",
      source: "fishnet_id",
      sort: false,
      ttoken: "objekti.fishnet_id",
      tooltip: "objekti.ifishnet_id",
      type: "numeric",
    },
    {
      title: "fishnet",
      source: "fishnet",
      sort: true,
      ttoken: "objekti.fishnet",
      type: "numeric"
    },
    {
      title: "status",
      source: "status",
      filter: true,
      ttoken: "objekti.status",
      tooltip: "objekti.istatus",
      type: "text",
    },
    {
      title: "Kat",
      source: "kat",
      sort: false,
      ttoken: "objekti.kat",
      tooltip: "objekti.kat",
      type: "numeric",
    },
    {
      title: "Stambeno",
      source: "stambeno",
      sort: false,
      ttoken: "objekti.stambeno",
      tooltip: "objekti.stambeno",
      type: "numeric",
    },
    {
      title: "Poslovno",
      source: "poslovno",
      sort: false,
      ttoken: "objekti.poslovno",
      tooltip: "objekti.poslovno",
      type: "numeric",
    },
    {
      title: "Garaza",
      source: "garaza",
      sort: false,
      ttoken: "objekti.garaza",
      tooltip: "objekti.garaza",
      type: "numeric",
    },
    {
      title: "Pomocno",
      source: "pomocno",
      sort: false,
      ttoken: "objekti.pomocno",
      tooltip: "objekti.pomocno",
      type: "numeric",
    },
    {
      title: "Balk_ter",
      source: "balk_ter",
      sort: false,
      ttoken: "objekti.balk_ter",
      tooltip: "objekti.balk_ter",
      type: "numeric",
    },
    {
      title: "Z_func_o",
      source: "z_func_o",
      sort: false,
      ttoken: "objekti.z_func_o",
      tooltip: "objekti.z_func_o",
      type: "numeric",
    },
    {
      title: "Neizgr_gr",
      source: "neizgr_gr",
      sort: false,
      ttoken: "objekti.neizgr_gr",
      tooltip: "objekti.neizgr_gr",
      type: "numeric",
    },
    {
      title: "Ostalo",
      source: "ostalo",
      sort: false,
      ttoken: "objekti.ostalo",
      tooltip: "objekti.ostalo",
      type: "numeric",
    },
    {
      title: "Ukupno",
      source: "ukupno",
      sort: false,
      ttoken: "objekti.ukupno",
      tooltip: "objekti.ukupno",
      type: "numeric",
    },
    {
      title: "Fishnet ID",
      source: "fishnet_id",
      sort: false,
      ttoken: "objekti.fishnet",
      tooltip: "objekti.fishnet",
      type: "numeric",
      readonly: true
    },
    {
      title: "Projekt ID",
      source: "projekt_id",
      sort: false,
      ttoken: "objekti.projekt",
      tooltip: "objekti.projekt",
      type: "numeric",
      readonly: true
    },
    {
      title: "KO.Link",
      source: "btn_show_object",
      tooltip: "buttons.show_object",
      ttoken: "objekti.ko_link",
      type: "button",
      icon: "open_in_new",
      action: "show_object",
      padding: "none",
      sort: false
    },
    {
      title: "Naselje",
      source: "naselje",
      ttoken: "objekti.naselje",
      type: "text",
      readonly: true
    },
    {
      title: "Ulica",
      source: "ulica",
      ttoken: "objekti.ulica",
      type: "text",
      readonly: true
    },
    {
      title: "kb",
      source: "kb",
      ttoken: "objekti.kb",
      type: "text",
      readonly: true
    },
    {
      title: "adresa_full",
      source: "adresa_full",
      ttoken: "objekti.adresa_objekta",
      type: "text",
      readonly: true
    },
    {
      title: "kn zona",
      source: "kn_zona",
      ttoken: "objekti.kn_zona",
      type: "text",
      readonly: true
    },
    {
      title: "PRE PT",
      source: "pre_pt",
      ttoken: "objekti.pre_pt",
      type: "numeric",
      readonly: true
    },
    {
      title: "PRE PB",
      source: "pre_pb",
      ttoken: "objekti.pre_pb",
      type: "numeric",
      readonly: true
    },
    {
      title: "PRE PN",
      source: "pre_pn",
      ttoken: "objekti.pre_pn",
      type: "numeric",
      readonly: true
    },
    {
      title: "KN Koef",
      source: "kn_koef",
      ttoken: "objekti.kn_koef",
      type: "numeric",
      readonly: true
    },
    {
      title: "Lokacija ID",
      source: "lokacija_id",
      ttoken: "objekti.lokacija_id",
      type: "numeric",
      readonly: true
    },
    {
      title: "Katastarska opcina",
      source: "ko_ime",
      ttoken: "komunalne_obveze.ko",
      type: "text",
      sort: true
    },
    {
      title: "Katastarska cestica",
      source: "kc",
      ttoken: "komunalne_obveze.kc",
      type: "text",
      sort: true
    },
    {
      title: "Broj katova",
      source: "broj_katova",
      ttoken: "objekti.broj_katova",
      type: "text",
      sort: true
    },
    {
      title: "Broj slika",
      source: "broj_slika",
      ttoken: "objekti.broj_slika",
      type: "numeric",
      sort: true
    },
    {
      title: "Broj etaža",
      source: "broj_etaza",
      ttoken: "objekti.broj_etaza",
      type: "numeric",
      sort: true
    },
    {
      title: "Broj dijelova",
      source: "broj_dijelova",
      ttoken: "objekti.broj_dijelova",
      type: "numeric",
      sort: true
    },
    {
      title: "Napomena picker",
      source: "napomena_picker",
      ttoken: "objekti.napomena_picker",
      type: "picker",
      filter: true,
      items: {
        labels: ["napomena.rusevina", "napomena.nije_nekretnina", "napomena.losa_slika", "napomena.dodati_tlocrt", "napomena.kriva_geometrija", "napomena.uptitna_namjena", "napomena.zapusteno", "napomena.u_izgradnji"],
        values: [1, 2, 3, 4, 5, 6, 7, 8],
        default: 1
      }
    },
    {
      title: "Napomena",
      source: "napomena",
      ttoken: "objekti.napomena",
      type: "multiline",
      rows: 2,
      maxRows: 2,
      sort: true,
      saveSpace: true,
      validation: {
        maxLength: 255
      }
    },
    {
      title: "Glavni objekt",
      source: "gl_obj",
      ttoken: "",
      items: {
        labels: ["common.no", "common.yes"],
        values: [false, true]
      },
      type: "boolean",
    },
    {
      title: "Pregledano",
      source: "pregledano",
      ttoken: "objekti.pregledano",
      items: {
        labels: ["common.no", "common.yes"],
        values: [false, true]
      },
      type: "boolean",
    },
    {
      title: "Foto 1",
      source: "foto_1",
      ttoken: "",
      type: "wholenum",
      readonly: true
    },
    {
      title: "Foto 2",
      source: "foto_2",
      ttoken: "",
      type: "wholenum",
      readonly: true
    },
    {
      title: "Foto 1 Extent",
      source: "foto_1_extent",
      ttoken: "",
      type: "text",
      readonly: true
    },
    {
      title: "Foto 2",
      source: "foto_2_extent",
      ttoken: "",
      type: "text",
      readonly: true
    },
    {
      title: "Images",
      source: "images",
      ttoken: "",
      type: "array",
      readonly: true
    },

    {
      title: "cx",
      source: "cx",
      ttoken: "",
      type: "numeric",
      sort: true
    },
    {
      title: "cy",
      source: "cy",
      ttoken: "",
      type: "numeric",
      sort: true
    },
    {
      title: "cz",
      source: "cz",
      ttoken: "",
      type: "numeric",
      sort: true
    },
    {
      title: "Komentar",
      source: "komentar",
      ttoken: "common.komentar",
      type: "text",
      sort: true
    },
    {
      title: "S",
      source: "s",
      ttoken: "objekti.namjene.s",
      type: "numeric",
      sort: true
    },
    {
      title: "K",
      source: "k",
      ttoken: "objekti.namjene.k",
      type: "numeric",
      sort: true
    },
    {
      title: "P",
      source: "p",
      ttoken: "objekti.namjene.p",
      type: "numeric",
      sort: true
    },
    {
      title: "J",
      source: "j",
      ttoken: "objekti.namjene.j",
      type: "numeric",
      sort: true
    },
    {
      title: "G",
      source: "g",
      ttoken: "objekti.namjene.g",
      type: "numeric",
      sort: true
    },
    {
      title: "BT",
      source: "bt",
      ttoken: "objekti.namjene.bt",
      type: "numeric",
      sort: true
    },
    {
      title: "F",
      source: "f",
      ttoken: "objekti.namjene.f",
      type: "numeric",
      sort: true
    },
    {
      title: "O",
      source: "o",
      ttoken: "objekti.namjene.o",
      type: "numeric",
      sort: true
    },
    {
      title: "Z",
      source: "z",
      ttoken: "objekti.namjene.z",
      type: "numeric",
      sort: true
    },
    {
      title: "N",
      source: "n",
      ttoken: "objekti.namjene.n",
      type: "numeric",
      sort: true
    },
    {
      title: "Stroke",
      source: "stroke",
      ttoken: "",
      type: "text",
      readonly: true
    },
    {
      title: "Stroke width" ,
      source: "stroke_wid",
      ttoken: "",
      type: "text",
      readonly: true
    },
    {
      title: "Stripes" ,
      source: "_stripes",
      ttoken: "",
      type: "numeric",
      readonly: true
    },
    {
      title: "Fill" ,
      source: "fill",
      ttoken: "",
      type: "text",
      readonly: true
    },
    {
      
      title: "Floors button",
      source: "show_katovi",
      tooltip: "buttons.katovi",
      ttoken: "buttons.katovi",
      type: "button",
      icon: "house_siding",
      action: "show_katovi",
      padding: "none",
      sort: false
    }, 
    {
      title: "QC Check Flag",
      source: "qc_check",
      ttoken: "qc.qc_check",
      items: {
        labels: ["common.no", "common.yes"],
        values: [false, true]
      },
      type: "boolean",
    },
    {
      title: "QC Check On",
      source: "qc_check_on",
      ttoken: "qc.qc_check_on",
      type: "datetime",
      readonly: true,
      export: {
        width: 20
      }
    },
    {
      title: "QC Check By",
      source: "qc_check_by",
      ttoken: "qc.qc_check_by",
      type: "text",
      readonly: true
    },
    {
      title: "QC Label",
      source: "label",
      ttoken: "qc.label",
      type: "text",
      readonly: true
    },
    {
      title: "Tip objekta",
      source: "objekt_tip_id",
      ttoken: "objekti.tip",
      type: "wholenum",
      readonly: true
    },
    commonFields.wkt,
    buttonFields.deselect
  ]
}

export default Objekti;
